




































































import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { requiredRule } from "@/lib/rules/requiredRule";
import { handleError } from "@/lib/utility/handleError";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { AddressWithGeoBase } from "@/models/address.entity";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportCurrentLocation extends mixins(ReportStepMixin, RulesMixin) implements IReportStep {
  header: IReportHeaderData = {
    title: "report.currentLocation.title",
    description: "report.currentLocation.description"
  };

  screen = ReportScreenEnum.currentLocation;

  isLoadingGeo = false;
  isGeoPermissionDenied = false;

  mounted() {
    // Initialize the location in the store if it doesn't exist
    if (!ReportModule.location) {
      ReportModule.updateLocation(new AddressWithGeoBase());
    }
  }

  get isAtVehicleLocation(): boolean | undefined {
    return ReportModule.isAtVehicleLocation;
  }

  set isAtVehicleLocation(isAtVehicleLocation: boolean | undefined) {
    ReportModule.setIsAtVehicleLocation(isAtVehicleLocation);
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get address() {
    return ReportModule.location || new AddressWithGeoBase();
  }

  set address(address: AddressWithGeoBase) {
    ReportModule.updateLocation({ ...address }); // Create a copy to ensure reactivity
  }

  valid = false;
  timepickerMenu = false;

  async getPositionIfTrue() {
    if (this.isAtVehicleLocation) {
      await this.getLocation();
    } else {
      this.address.geo.lat = 0;
      this.address.geo.lng = 0;
    }
  }

  async getLocation() {
    this.isLoadingGeo = true;
    this.isGeoPermissionDenied = false;
    try {
      const geo: any = await new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }

        navigator.geolocation.getCurrentPosition(
          pos => {
            resolve(pos);
          },
          err => {
            // Check if error is due to permission denial (code 1)
            if (err.code === 1) {
              this.isGeoPermissionDenied = true;
            }
            reject(err);
          }
        );
      });
      this.address.geo.lat = geo.coords.latitude;
      this.address.geo.lng = geo.coords.longitude;
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoadingGeo = false;
    }
  }

  retryGeolocation() {
    this.getLocation();
  }

  get isDone() {
    return this.valid && this.isAtVehicleLocation !== undefined && !this.isLoadingGeo;
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
